<template>
  <div class="contractors-main-table">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'ContractorsMainTable',
  };
</script>
